import { gql } from '@apollo/client';

export const UPDATE_DRIVER_RATING = gql`
  mutation updateDriverRating($id: String!, $userJobData: UpdateUserJobInput) {
    updateDriverRating(id: $id, userJobData: $userJobData) {
      success
      message
    }
  }
`;